import { ErrorLink } from '@apollo/client/link/error';

import { reportError } from '@utils/monitoring';

import { getOperationKind } from './get_operation_kind';

export const buildErrorLink = () =>
  new ErrorLink(({ error, operation }) => {
    if (error) {
      reportError(new Error(error.message), {
        tags: { graphql: getOperationKind(operation) },
        metadata: {
          operationName: operation.operationName ?? 'unknown',
          variables: operation.variables,
        },
      });
    }
  });
